module.exports = __webpack_public_path__ + "images/79c7ea68da6cb20dd85b0ff25ed27ef1.gif";